/* import React from 'react'
import './PageFooter.css'

const Footer = () => {
	return (
		<div>
			<footer
				className='pageFooter'
				style={{ marginTop: '4rem', paddingTop: '4rem', paddingBottom: '4rem' }}
			>
				<p>High School Ball Hockey League</p>
				<p>
					Questions about Stats & Standings?{' '}
					<a href='mailto:matt@shireystatsandstandings.com'> Email Us!</a>
				</p>
			</footer>
		</div>
	)
}

export default Footer */
import React from 'react'
import './Footer.css'

const Footer = () => {
	return (
		<div style={{ backgroundColor: '#b42328' }}>
			<footer>
				<div>
					<div className='row'>
						<div className='col text-center'>
							<h1
								className='font-weight-light text-capitalize p-3'
								style={{ color: 'white' }}
							>
								USA Ball Hockey
							</h1>
							{/* <h4
								className='font-weight-bold font-italic'
								style={{ color: 'white' }}
							>
								Growing the game, one school at a time.
							</h4> */}
							<div className='py-3'>
								<a
									href='https://www.facebook.com/usabhnationalteams'
									target='_blank'
									style={{ color: 'white' }}
									// style={{ color: '#11284b', textShadow: 'white 2px 2px 2px' }}
								>
									<i className='fa fa-facebook-square fa-4x mx-3'></i>
								</a>
							</div>
							<p
								className='py-4 m-0 copyright'
								style={{ color: 'white', backgroundColor: '#172d4b' }}
							>
								A Web Application by{' '}
								<a
									href='https://www.shireystatsandstandings.com/#'
									target='_blank'
									style={{ color: 'white' }}
								>
									Shirey Stats and Standings, LLC
								</a>
							</p>
						</div>
					</div>
				</div>
			</footer>
		</div>
	)
}

export default Footer
